import { render, staticRenderFns } from "./linkCenter.vue?vue&type=template&id=3d299b2d&scoped=true"
import script from "./linkCenter.vue?vue&type=script&lang=js"
export * from "./linkCenter.vue?vue&type=script&lang=js"
import style0 from "./linkCenter.vue?vue&type=style&index=0&id=3d299b2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d299b2d",
  null
  
)

export default component.exports